var _circle, _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPoints(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 164"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4",
    cx: 14.5,
    cy: 14.7766,
    r: 14.5,
    fill: "#FF9901",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "lock"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1212_2804",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 5,
    width: 20,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 6,
    y: 5.27661,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1212_2804)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hotel_class"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1212_2804",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 3,
    width: 25,
    height: 25
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box_2",
    x: 4.45044,
    y: 3.40527,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1212_2804)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hotel_class_2",
    d: "M18.2696 16.9723L20.913 14.7114L23 14.8853L19.9391 17.5462L20.8435 21.494L19.0696 20.4157L18.2696 16.9723ZM16.6348 11.894L15.9043 10.1897L16.7043 8.27661L18.3043 12.0505L16.6348 11.894ZM11.7652 18.5897L13.9565 17.2679L16.1478 18.607L15.5739 16.1027L17.5043 14.4331L14.9652 14.207L13.9565 11.8418L12.9478 14.1897L10.4087 14.4157L12.3391 16.1027L11.7652 18.5897ZM9.66087 21.494L10.7913 16.607L7 13.3201L12.0087 12.8853L13.9565 8.27661L15.9043 12.8853L20.913 13.3201L17.1217 16.607L18.2522 21.494L13.9565 18.9027L9.66087 21.494Z",
    fill: "#FF9901"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoints);
export default __webpack_public_path__ + "static/media/points.c4f5c083f7d8eabe9e81e156423a1b85.svg";
export { ForwardRef as ReactComponent };